import axios from "axios";
import React, { useEffect, useState } from "react";
import { FiEdit, FiSave, FiTrash2, FiX } from "react-icons/fi";
import { showErrorToast, showSuccessToast } from "../../utils/toaster";
import { baseurl } from "../../config/url";

const UpdateProductForm = ({
  product,
  getAllProducts,
  setIsEditMode,
  categories,
}) => {
  const validUnits = [
    "Perkg",
    "PerNumber",
    "PerMeter",
    "PerLiter",
    "PerCum",
    "PerCft",
    "PerMT",
    "PerBox",
    "PerRF",
    "PerRM",
    "PerLtr",
    "PerSqft",
    "perBundle",
    "PerRoll",
  ];

  const [updatedProduct, setUpdatedProduct] = useState(() => {
    return product ? JSON.parse(JSON.stringify(product)) : {};
  });
  const [editspec, seteditspec] = useState(null);
  const [price, setPrice] = useState(updatedProduct?.price || ""); // Initialize price state
  const [unit, setUnit] = useState(updatedProduct?.unit || ""); // Initialize unit state

  const [showSpecification, setshowSpecification] = useState(false);
  const [subcategories, setSubcategories] = useState([]);
  const [specifications, setSpecifications] = useState(() => {
    return product?.specifications
      ? JSON.parse(JSON.stringify(product.specifications))
      : [];
  });
  const [newSpec, setNewSpec] = useState({ key: "", value: "" });
  const [imageFile, setImageFile] = useState(null);
  const [selectedCategory, setSelectedCategory] = useState(
    updatedProduct?.category?._id || ""
  );
  const [selectedSubcategory, setSelectedSubcategory] = useState(
    updatedProduct?.subcategory?._id || ""
  );

  const [deliveryCharge, setDeliveryCharge] = useState({
    baseCharge: product.deliveryCharge?.baseCharge || "",
    perKmCharge: product.deliveryCharge?.perKmCharge || "",
    weightCharge: product.deliveryCharge?.weightCharge || "",
    maxDistance: product.deliveryCharge?.maxDistance || "",
  });

  const [deliveryPreference, setDeliveryPreference] = useState({
    duration: product.deliveryPreference?.duration || "",
    unit: product.deliveryPreference?.unit || "",
  });

  const handleChange = (e) => {
    const { name, value } = e.target;
    setUpdatedProduct((prevProduct) => ({
      ...prevProduct,
      [name]: value,
    }));
  };

  const handlePriceUnitChange = (e) => {
    const unit = e.target.value.trim();
    setDeliveryPreference((prev) => ({ ...prev, unit: unit }));
  };

  const handleSpecificationChange = (index, field, value) => {
    const updatedSpecifications = [...specifications]; // Use the state directly
    updatedSpecifications[index][field] = value; // Update the specific field
    setSpecifications(updatedSpecifications); // Update the state with the new specifications
  };

  const addSpecification = () => {
    // Check if both key and value are provided
    if (!newSpec.key || !newSpec.value) {
      showErrorToast("Both key and value are required for a specification.");
      return;
    }

    // If valid, add the new specification
    setSpecifications((prevSpecifications) => {
      return [...prevSpecifications, newSpec];
    });

    setNewSpec({ key: "", value: "" });
    setshowSpecification(false);
  };

  const removeSpecification = (index) => {
    const updatedSpecifications = [...specifications];
    console.log(updatedSpecifications);
    updatedSpecifications.splice(index, 1);
    console.log(updatedSpecifications);
    setSpecifications(updatedSpecifications);
  };

  const handleSaveSpecification = (index) => {
    const updatedSpecifications = [...specifications];
    const spec = updatedSpecifications[index];

    // Check if both key and value are present
    if (!spec.key || !spec.value) {
      showErrorToast("Both key and value are required.");
      return;
    }

    // If valid, save the updated specification
    setSpecifications(updatedSpecifications);
    seteditspec(null); // Close the edit mode after saving
  };

  const validateForm = () => {
    const {
      name: productName,
      description: productDescription,
      size: productSize,
      minquantity,
      maxquantity,
      price: productPrice,
      stock,
      priceUnit,
      saleType,
    } = updatedProduct;
    if (!selectedCategory) {
      showErrorToast("Please select a category.");
      return false;
    }
    if (!selectedSubcategory) {
      showErrorToast("Please select a subcategory.");
      return false;
    }
    if (!productName) {
      showErrorToast("Product Name is required.");
      return false;
    }
    if (!productDescription) {
      showErrorToast("Product Description is required.");
      return false;
    }
    // if (!productSize) {
    //   showErrorToast("Product Size is required.");
    //   return false;
    // }
    if (!minquantity) {
      showErrorToast("Minimum Quantity is required.");
      return false;
    }
    if (!maxquantity) {
      showErrorToast("Maximum Quantity is required.");
      return false;
    }
    // if (!productPrice || productPrice <= 0) {
    //   showErrorToast("Please enter a valid product price.");
    //   return false;
    // }
    if (!stock || +stock < 0) {
      showErrorToast("Please enter a valid stock quantity.");
      return false;
    }
    if (+minquantity > +maxquantity) {
      showErrorToast("Minimum quantity cannot exceed maximum quantity.");
      return false;
    }

    if (+maxquantity < +minquantity) {
      showErrorToast("Maximum quantity cannot be less than minimum quantity.");
      return false;
    }

    if (+maxquantity > +stock) {
      showErrorToast("Maximum quantity cannot exceed stock quantity.");
      return false;
    }

    if (!saleType) {
      showErrorToast("Sale Mode is required.");
      return false;
    }
    // if (!imageFile) {
    //   showErrorToast("Image is required.");
    //   return false;
    // }

    // if (imageFile.length == 0) {
    //   showErrorToast("At least one additional image is required.");
    //   return false;
    // }

    if (!deliveryPreference.duration || +deliveryPreference.duration <= 0) {
      showErrorToast("Please provide a valid delivery duration.");
      return false;
    }
    if (!deliveryPreference.unit) {
      showErrorToast(
        "Please select a delivery unit (e.g., days, weeks, months, years)."
      );
      return false;
    }

    if (!priceUnit) {
      showErrorToast("Price unit is required. Please select a valid unit.");
      return false; // Exit validation
    }

    if (!validUnits.includes(priceUnit)) {
      showErrorToast(
        `Invalid price unit: ${priceUnit}. Must be one of ${validUnits.join(
          ", "
        )}.`
      );
      return false; // Exit validation
    }






    return true;
  };

  const handleSave = async () => {
    if (!validateForm()) {
      return; // Stop submission if validation fails
    }

    const formData = new FormData();
    delete updatedProduct.deliveryPreference;
    Object.entries(updatedProduct).forEach(([key, value]) => {
      if (key === "specifications") {
        formData.append(key, JSON.stringify(specifications));
      } else {
        formData.append(key, value);
      }
    });
    formData.delete("category");
    formData.append("category", selectedCategory);
    formData.delete("subcategory");
    formData.append("subcategory", selectedSubcategory);
    Object.entries(deliveryPreference).forEach(([key, value]) => {
      formData.append(`deliveryPreference[${key}]`, value);
    });

    if (imageFile) {
      formData.append("file", imageFile);
    } else {
      formData.delete("image");
    }
    const promisearray = [
      axios.put(
        `${baseurl}/api/seller/update-product/${updatedProduct._id}`,
        formData,
        {
          headers: {
            Authorization: `Bearer ${localStorage.getItem("token")}`,
            "Content-Type": "multipart/form-data",
          },
        }
      ),
    ];

    if (updatedProduct.saleType === "Sale By OGCS") {
      let data = {
        baseCharge: deliveryCharge.baseCharge,
        perKmCharge: deliveryCharge.perKmCharge,
        weightCharge: deliveryCharge.weightCharge,
        maxDistance: deliveryCharge.maxDistance,
      };
      let url = `${baseurl}/api/deliverycharge/${updatedProduct?.deliveryCharge?._id}`;
      if (!updatedProduct?.deliveryCharge?._id) {
        data.productId = updatedProduct._id;
        data.seller = updatedProduct.seller;
        url = `${baseurl}/api/deliverycharge`;
        promisearray.push(
          axios.post(url, data, {
            headers: {
              Authorization: `Bearer ${localStorage.getItem("token")}`,
            },
          })
        );
      } else {
        promisearray.push(
          axios.put(url, data, {
            headers: {
              Authorization: `Bearer ${localStorage.getItem("token")}`,
            },
          })
        );
      }
    }
    try {
      await Promise.all(promisearray);
      showSuccessToast("Product Updated Successfully!");
      getAllProducts();
      setIsEditMode(false);
    } catch (error) {
      console.error("Error updating product:", error);
      showErrorToast("Failed to update product. Please try again.");
    }
  };

  let getsubcategory = () => {
    if (!selectedCategory) return;
    axios
      .get(`${baseurl}/api/subcategory/category/${selectedCategory}`)
      .then((response) => {
        let data = response?.data || [];
        setSubcategories(data);
        setSelectedSubcategory(data[0]?._id);
      })
      .catch((error) => {
        showErrorToast("Error fetching subcategories:", error.message); // Display error toast
      });
  };
  useEffect(() => {
    getsubcategory();
  }, [selectedCategory]);

  return (
    <div className="p-6 bg-white shadow-md rounded-lg">
      <h2 className="text-lg font-semibold text-gray-800 mb-1">
        {/* Edit Product */}
      </h2>
      <div className="grid grid-cols-1 gap-6 gap-y-1 md:grid-cols-2">
        {/* Product Name */}
        <div>
          <label className="block text-sm font-medium text-gray-700">
            Product Name
          </label>
          <input
            type="text"
            name="name"
            value={updatedProduct.name || ""}
            onChange={handleChange}
            className="w-full mt-1 p-2 border border-gray-300 rounded-md focus:outline-none focus:ring focus:ring-blue-300"
          />
        </div>
        {/* Description */}
        <div>
          <label className="block text-sm font-medium text-gray-700">
            Description
          </label>
          <input
            type="text"
            name="description"
            value={updatedProduct.description || ""}
            onChange={handleChange}
            className="w-full mt-1 p-2 border border-gray-300 rounded-md focus:outline-none focus:ring focus:ring-blue-300"
          />
        </div>

        {/* Price */}
        <div>
          <label className="block text-sm font-medium text-gray-700">
            Price
          </label>
          <div className="flex gap-2 items-center mt-1">
            <input
              type="number"
              name="price"
              value={updatedProduct.price || ""}
              onChange={handleChange}
              className="w-1/2 p-2 border border-gray-300 rounded-md focus:outline-none focus:ring focus:ring-blue-300"
            />

            <select
              value={updatedProduct.priceUnit || ""}
              onChange={handlePriceUnitChange}
              name="priceUnit"
              className="w-1/2 p-2 border border-gray-300 rounded-md focus:outline-none focus:ring focus:ring-blue-300"
            >
              <option value="">--Select Unit--</option>
              {validUnits.map((unit) => (
                <option key={unit} value={unit}>
                  {unit}
                </option>
              ))}
            </select>
          </div>
        </div>

        {/* Size */}
        <div>
          <label className="block text-sm font-medium text-gray-700">
            Size
          </label>
          <input
            type="text"
            name="size"
            value={updatedProduct.size || ""}
            onChange={handleChange}
            className="w-full mt-1 p-2 border border-gray-300 rounded-md focus:outline-none focus:ring focus:ring-blue-300"
          />
        </div>

        {/* Stock */}
        <div>
          <label className="block text-sm font-medium text-gray-700">
            Stock
          </label>
          <input
            type="text"
            name="stock"
            value={updatedProduct.stock || ""}
            onChange={handleChange}
            className="w-full mt-1 p-2 border border-gray-300 rounded-md focus:outline-none focus:ring focus:ring-blue-300"
          />
        </div>

        {/* Minimum Quantity */}
        <div>
          <label className="block text-sm font-medium text-gray-700">
            Minimum Quantity
          </label>
          <input
            type="text"
            name="minquantity"
            value={updatedProduct.minquantity || ""}
            onChange={handleChange}
            className="w-full mt-1 p-2 border border-gray-300 rounded-md focus:outline-none focus:ring focus:ring-blue-300"
          />
        </div>

        {/* Maximum Quantity */}
        <div>
          <label className="block text-sm font-medium text-gray-700">
            Maximum Quantity
          </label>
          <input
            type="text"
            name="maxquantity"
            value={updatedProduct.maxquantity || ""}
            onChange={handleChange}
            className="w-full mt-1 p-2 border border-gray-300 rounded-md focus:outline-none focus:ring focus:ring-blue-300"
          />
        </div>

        {/* visibility level
        <div>
          <label className="block text-sm font-medium text-gray-700">
            Visibility Level
          </label>
          <select
            name="visibilityLevel"
            value={updatedProduct.visibilityLevel || ""}
            onChange={handleChange}
            className="w-full mt-1 p-2 border border-gray-300 rounded-md focus:outline-none focus:ring focus:ring-blue-300"
          >
            <option value="">--Select Visibility Level--</option>
            <option value="1X">1X</option>
            <option value="2X">2X</option>
            <option value="3X">3x</option>
            <option value="4X">4X</option>
          </select>
        </div>
 */}
        <div>
          <label
            htmlFor="category-dropdown"
            className="block text-sm font-medium text-gray-700"
          >
            Select Category:
          </label>
          <select
            id="category-dropdown"
            value={selectedCategory}
            onChange={(e) => setSelectedCategory(e.target.value)}
            className="w-full mt-1 p-2 border border-gray-300 rounded-md focus:outline-none focus:ring focus:ring-blue-300"
          >
            <option value="" disabled>
              Select a category
            </option>
            {categories.map((category) => (
              <option key={category._id} value={category._id}>
                {category.name}
              </option>
            ))}
          </select>
        </div>
        <div>
          <label
            htmlFor="subcategory-dropdown"
            className="block text-sm font-medium text-gray-700"
          >
            Select Subcategory:
          </label>
          <select
            id="subcategory-dropdown"
            value={selectedSubcategory} // State for selected subcategory
            onChange={(e) => setSelectedSubcategory(e.target.value)} // Handle selection
            className="w-full mt-1 p-2 border border-gray-300 rounded-md focus:outline-none focus:ring focus:ring-blue-300"
          >
            <option value="" disabled>
              Select a subcategory
            </option>
            {subcategories.map((subcategory) => (
              <option key={subcategory._id} value={subcategory._id}>
                {subcategory.name}
              </option>
            ))}
          </select>
        </div>
      </div>

      <div className="flex gap-4 my-2 items-center">
        {/* Delivery Duration Input */}
        <div className="flex-1">
          <label className="block text-sm font-medium text-gray-700">
            Enter Estimated Delivery Duration (e.g., 5)
            <input
              type="number"
              min={0}
              name="duration" // Associate the name with the state property
              value={deliveryPreference.duration}
              onChange={(e) =>
                setDeliveryPreference((prev) => ({
                  ...prev,
                  duration: e.target.value,
                }))
              }
              placeholder="Enter amount (e.g., 5)"
              className="w-full p-2 border rounded focus:ring focus:ring-blue-300"
            />
          </label>
        </div>

        <div className="flex-1 mb-2">
          {/* Delivery Unit Select */}
          <label className="text-sm font-medium text-gray-700">
            Delivery Preference Unit
          </label>
          <select
            name="unit" // Associate the name with the state property
            value={deliveryPreference?.unit}
            onChange={(e) =>
              setDeliveryPreference((prev) => ({
                ...prev,
                unit: e.target.value,
              }))
            }
            className="w-full p-2 border rounded-md focus:ring focus:ring-blue-300"
          >
            <option value="days">Days</option>
            <option value="weeks">Weeks</option>
            <option value="months">Months</option>
            <option value="years">Years</option>
          </select>
        </div>
      </div>

      Sale Mode
      <div className="mb-2">
        <label className="block text-sm font-medium text-gray-700">
          Sale Mode
        </label>
        <select
          name="saleType"
          value={updatedProduct.saleType}
          onChange={handleChange}
          className="w-full mt-1 p-2 border border-gray-300 rounded-md focus:outline-none focus:ring focus:ring-blue-300"
        >
          <option value="">--Select--</option>
          <option value="Sale By Seller">Sale by Seller</option>
          <option value="Sale By OGCS">Sale by OGCS</option>
          <option value="Sale By BestPrice"> Sale By BestPrice </option>
        </select>
      </div>

      Delivery Charges Section
      {updatedProduct.saleType === "Sale By OGCS" && (
        <div className="mt-6">
          <h3 className="text-lg font-semibold text-gray-800 mb-4">
            Delivery Charges
          </h3>
          <div className="grid grid-cols-1 gap-6 gap-y-1 md:grid-cols-2">
            <div>
              <label className="block text-sm font-medium text-gray-700">
                Base Charge
              </label>
              <input
                type="number"
                min={0}
                value={deliveryCharge.baseCharge}
                onChange={(e) =>
                  setDeliveryCharge((prev) => ({
                    ...prev,
                    baseCharge: e.target.value,
                  }))
                }
                className="w-full mt-1 p-2 border border-gray-300 rounded-md focus:outline-none focus:ring focus:ring-blue-300"
              />
            </div>
            <div>
              <label className="block text-sm font-medium text-gray-700">
                Per Km Charge
              </label>
              <input
                type="number"
                min={0}
                value={deliveryCharge.perKmCharge}
                onChange={(e) =>
                  setDeliveryCharge((prev) => ({
                    ...prev,
                    perKmCharge: e.target.value,
                  }))
                }
                className="w-full mt-1 p-2 border border-gray-300 rounded-md focus:outline-none focus:ring focus:ring-blue-300"
              />
            </div>
            <div>
              <label className="block text-sm font-medium text-gray-700">
                Weight Charge
              </label>
              <input
                type="number"
                min={0}
                value={deliveryCharge.weightCharge}
                onChange={(e) =>
                  setDeliveryCharge((prev) => ({
                    ...prev,
                    weightCharge: e.target.value,
                  }))
                }
                className="w-full mt-1 p-2 border border-gray-300 rounded-md focus:outline-none focus:ring focus:ring-blue-300"
              />
            </div>
            <div>
              <label className="block text-sm font-medium text-gray-700">
                Max Km Distance
              </label>
              <input
                type="number"
                min={0}
                value={deliveryCharge.maxDistance}
                onChange={(e) =>
                  setDeliveryCharge((prev) => ({
                    ...prev,
                    maxDistance: e.target.value,
                  }))
                }
                className="w-full mt-1 p-2 border border-gray-300 rounded-md focus:outline-none focus:ring focus:ring-blue-300"
              />
            </div>
          </div>
        </div>
      )}

      <label className="block mb-1 text-sm font-medium text-gray-700">
        <div className="flex items-center space-x-4">
          {/* Display the current or new image */}
          <img
            src={
              imageFile
                // ? URL.createObjectURL(imageFile) // Preview the newly selected image
                // : `data:${updatedProduct.image?.contentType};base64,${updatedProduct.image?.data}` ||
                //   "/placeholder.png" // Fallback to existing image or placeholder
                ? URL.createObjectURL(imageFile)
                : updatedProduct.image || "/placeholder.png"
            }
            alt="Product"
            className="w-24 h-24 object-cover rounded border"
          />
          <input
            type="file"
            accept="image/*"
            onChange={(e) => setImageFile(e.target.files[0])} // Update state on file selection
            className="block w-full text-sm text-gray-500 file:mr-4 file:py-2 file:px-4 file:rounded file:border file:border-gray-300 file:text-sm file:font-semibold file:bg-gray-100 file:text-gray-700 hover:file:bg-gray-200"
          />
        </div>
      </label>



      {/* Specifications Section */}
      <div className="mt-4">
        <h3 className="text-lg font-semibold text-gray-800 mb-1">
          Specifications
        </h3>
        {specifications?.map((spec, index) => (
          <div key={index} className="flex items-center justify-between mb-4">
            {editspec == index ? (
              <div className="flex gap-2 justify-between w-full">
                <input
                  type="text"
                  value={spec.key}
                  onChange={(e) =>
                    handleSpecificationChange(index, "key", e.target.value)
                  }
                  className="p-2 border border-gray-300 rounded-md"
                />
                <input
                  type="text"
                  value={spec.value}
                  onChange={(e) =>
                    handleSpecificationChange(index, "value", e.target.value)
                  }
                  className="p-2 border border-gray-300 rounded-md"
                />
                <div className="flex gap-2">
                  <button
                    className="text-blue-500"
                    onClick={() => handleSaveSpecification(index)}
                  >
                    <FiSave fontSize={20} />
                  </button>

                  <button
                    onClick={() => seteditspec(null)}
                    className="text-red-500"
                  >
                    <FiX fontSize={20} />
                  </button>
                </div>
              </div>
            ) : (
              <div className="flex items-center w-full justify-between">
                <span className="mr-2">
                  {spec.key}: {spec.value}
                </span>
                <div>
                  <button
                    onClick={() => seteditspec(index)}
                    className="text-blue-500"
                  >
                    <FiEdit fontSize={20} />
                  </button>
                  <button
                    onClick={() => removeSpecification(index)}
                    className="text-red-500 ml-2"
                  >
                    <FiTrash2 fontSize={20} />
                  </button>
                </div>
              </div>
            )}
          </div>
        ))}
        {showSpecification && (
          <div className="flex gap-2 justify-between w-full">
            <input
              type="text"
              value={newSpec.key}
              onChange={(e) => setNewSpec({ ...newSpec, key: e.target.value })}
              placeholder="Enter specification key"
              className="p-2 border border-gray-300 rounded-md"
            />
            <input
              type="text"
              value={newSpec.value}
              onChange={(e) =>
                setNewSpec({ ...newSpec, value: e.target.value })
              }
              placeholder="Enter specification value"
              className="p-2 border border-gray-300 rounded-md"
            />
            <div className="flex gap-2">
              <button onClick={addSpecification} className="text-blue-500">
                <FiSave fontSize={20} />
              </button>

              <button
                onClick={() => setshowSpecification(false)}
                className="text-red-500"
              >
                <FiX fontSize={20} />
              </button>
            </div>
          </div>
        )}

        <button
          onClick={() => setshowSpecification(true)}
          className="text-blue-500"
        >
          Add Specification
        </button>
      </div>
      <p className="mt-2 text-sm text-gray-600">
        If you want to update to sale type "Sale By Seller" and "Sale By OGCS" or "Product on Hire," please contact our team at <a href="mailto:support@ogcs.co.in" className="text-blue-500">support@ogcs.co.in</a> or call <a href="tel:9898989898" className="text-blue-500">9967610135</a>.
      </p>
      {/* Save and Cancel */}
      <div className="mt-6 flex gap-4">
        <button
          onClick={handleSave}
          className="px-4 py-2 bg-blue-500 text-white rounded-md"
        >
          Save
        </button>
        <button
          onClick={() => setIsEditMode(false)}
          className="px-4 py-2 bg-gray-500 text-white rounded-md"
        >
          Cancel
        </button>
      </div>
    </div>
  );
};

export default UpdateProductForm;
